export default __webpack_public_path__ + "static/media/Webchat_White.17a6d5a0.svg";